import "./index.css";
import { useState, useEffect } from "react";
import { Select, notification } from "antd";
import { useAuth } from "../../context/auth";

const ConnectorTypeDropdown = ({ ...props }) => {
  const { accessToken } = useAuth();

  const [connectorTypes, setConnectorTypes] = useState([]);
  useEffect(() => {
    async function getConnectorTypes() {
      const url = new URL('/api/connector-type', window.location);

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      });
      if (res.ok) {
        const { connectorTypes } = await res.json();
        setConnectorTypes(connectorTypes);
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    getConnectorTypes();
  }, [accessToken]);

  return (
    <Select
      {...props}
      showSearch
      placeholder="Connector Type Name"
      optionFilterProp="children"
    >
      {connectorTypes.map(connectorType => (
        <Select.Option key={connectorType.id} value={connectorType.id}>
          {connectorType.name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ConnectorTypeDropdown;
